import React, { Fragment } from 'react'
import { withRouter, matchPath, Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { do_action } from '../../actions'
import { setGroup, setCustomer, setPageSeo } from '../../actions/index'
import ModalSignIn from '../Modal/ModalSignIn'
import GoogleTranslate from '../Common/GoogleTranslate'
import { Cookies } from 'react-cookie'

const cookies = new Cookies()

class Header extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            quote_id: ''
        }
    }

    componentWillMount() {

        let {dispatch} = this.props;
        do_action('get_all_group', {})
            .then(data => {
                if (data.signal) {
                    dispatch(setGroup(data.data));
                } else {
                    return window.location.href = '/';
                }
            })
            .catch(err => console.log(err));

        do_action('page_seo_key', {})
                .then(data => {
                    if (data.signal) {
                        dispatch(setPageSeo(data.data));
                    }
                })
                .catch(err => console.log(err));

        const token = cookies.get('customer')
        if (token) do_action('get_customer_by_token', { token })
            .then(data => {
                if (data.signal) {
                    dispatch(setCustomer(data.data.customer))
                } else {
                    cookies.remove('customer', {path : '/', maxAge: 96969696})
                }
            })
            .catch(err => console.log(err))
    }

    getParam = (location) => {
        const modified = location.substring(1, location.length)
        return modified.substring(modified.indexOf('/') + 1, modified.length)
    }

    processPath = (path, idx) => {
        let {quote, location} = this.props;
        if (!quote && path == '/detail') {
            return 'active';
        }

        if (quote) {
            let {pathname} = location;
            let quotes_step = quote.step;
            if (pathname.indexOf(path) >=0 ) {
                return 'active';
            } else {
                if (idx < quotes_step) {
                    return 'activate';
                } else {
                    return '';
                }
            }
        }
    }

    logoutVendor(e) {
        e.preventDefault();
        let {history, dispatch} = this.props;
        cookies.remove('customer', {path : '/', maxAge: 96969696})
        
        dispatch(setCustomer({}))
    }

    redirect = (path, idx, e) => {
        e.preventDefault();
        let {quote, history} = this.props;
        if (quote) {
            if (idx <= quote.step) {
                history.push(`/quotes${path}/${quote._id}`);
            }
        }
    }

    render() {
        let {location, customer, dispatch} = this.props;
        let {pathname} = location;
        let isSuccess = pathname.indexOf('success') >= 0;
        return (
            <div className="header">
                {/* <div className="h-top">
                    <div className="container">
                    <ul className="nav navbar-nav navbar-left">
                        <li><GoogleTranslate /></li>
                    </ul>
                    <ul className="nav navbar-nav navbar-right">
                        {(Object.keys(customer).length !== 0) ? (
                            <li>
                                <a href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" className="lang fontSemiBold">
                                    <img src="/images/user-logo.png" alt="Ruhu" className="avatar mr-5" />
                                    {`Hello ${customer.last_name}`}
                                    <span className="fa fa-angle-down ml-5"></span>
                                </a>
                                
                                <ul className="dropdown-menu dropdown-menu-right">
                                    <li><Link to="/profile">My profile</Link></li>
                                    <li><Link to="/my-quotes">My quotes</Link></li>
                                    <li><a href="#" onClick={this.logoutVendor.bind(this)}>Logout</a></li>
                                </ul>
                            </li>
                        ) :
                            <Fragment>
                                <li>
                                    <a href="#" className="h-signin" data-toggle="modal" data-target="#modal-sign-in" data-backdrop="static" data-keyboard="false"><img src="/images/logo-signin.png" alt="Ruhu" className="ico" />Signin</a>
                                </li>

                                <li>
                                    <Link to="/register" className="h-signin">Sign up</Link>
                                </li>
                            </Fragment>
                        }
                    </ul>
                </div>

                </div> */}
                <nav className="navbar navbar-default h-main">
                    <div className="container">
                        {/* Brand and toggle get grouped for better mobile display */}
                        <div className="navbar-header">
                            <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                                <span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar" />
                                <span className="icon-bar" />
                                <span className="icon-bar" />
                            </button>
                            <a href="/" className="navbar-brand">
                                <img src="/images/new/ruhu-logo-13.png" alt="HOME" style={{width: '150px'}}/>
                            </a>
                        </div>
                        <div>
                            < div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                                {!isSuccess && (
                                    <ul className="nav navbar-nav h-menu ml-60">
                                        {/* <li className={this.processPath('/detail', 1)}>
                                            <a href="#" onClick={this.redirect.bind(this, '/detail', 1)} >
                                                <span className="number">1</span>
                                                <span className="txt">Quote Detail</span>
                                            </a>
                                        </li> */}
                                        <li className={this.processPath('/room', 2)}>
                                            <a href="#" onClick={this.redirect.bind(this, '/room', 2)}>
                                                <span className="number">2</span>
                                                <span className="txt">Rooms</span>
                                            </a>
                                        </li>
                                        <li className={this.processPath('/contractor', 3)}>
                                            <a href="#" onClick={this.redirect.bind(this, '/contractor', 3)}>
                                                <span className="number">3</span>
                                                <span className="txt">Contractor</span>
                                            </a>
                                        </li>
                                        <li className={this.processPath('/designer-pm', 4)}>
                                            <a href="#" onClick={this.redirect.bind(this, '/designer-pm', 4)} >
                                                <span className="number">4</span>
                                                <span className="txt">Design/PM</span>
                                            </a>
                                        </li>
                                        <li className={`last ${this.processPath('/confirm', 5)}`}>
                                            <a href="#" onClick={this.redirect.bind(this, '/confirm', 5)}>
                                                <span className="number">5</span>
                                                <span className="txt">Confirm</span>
                                            </a>
                                        </li>
                                    </ul>
                                )}
                                
                            </div>
                        </div>

                        <ModalSignIn dispatch={dispatch} info={this.props.info}/>
                        
                    </div>
                </nav >
            </div >
        )
    }
}

function mapStateToProps(state) {
    const {customer, quote, info, pageSeo} = state
    return { 
        quote, 
        customer, 
        info,
        pageSeo 
    }
}

export default connect(mapStateToProps)(withRouter(Header))